import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaHome, FaShoppingBag } from 'react-icons/fa';
import './BookingSuccess.css';

const BookingSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const { refNo, bookId } = location.state || {};

  return (
    <div className="booking-success-page">
      <div className="container">
        <div className="success-content">
          <div className="success-icon">
            <FaCheckCircle />
          </div>
          
          <h1>Order Placed Successfully!</h1>
          <p className="success-message">
            Thank you for your order. We have received your request and will process it shortly.
          </p>
          
          {refNo && (
            <div className="order-details">
              <h3>Order Details</h3>
              <div className="detail-item">
                <span className="label">Reference Number:</span>
                <span className="value">{refNo}</span>
              </div>
              {bookId && (
                <div className="detail-item">
                  <span className="label">Booking ID:</span>
                  <span className="value">{bookId}</span>
                </div>
              )}
            </div>
          )}
          
          <div className="delivery-info">
            <h3>What's Next?</h3>
            <ul>
              <li>Your order will be delivered within 2-5 days</li>
              <li>We will contact you to confirm the delivery details</li>
              <li>Please keep the payment ready for cash on delivery orders</li>
              <li>You will receive updates via WhatsApp</li>
            </ul>
          </div>
          
          <div className="action-buttons">
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/products')}
            >
              <FaShoppingBag />
              Continue Shopping
            </button>
            
            <button 
              className="btn btn-secondary"
              onClick={() => navigate('/')}
            >
              <FaHome />
              Go Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingSuccess;
